import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'semantic-ui-react';

export function VerifiedCallerIdTableHeader(props) {
  const tableHeader = props.header.map((head, index) => {
    if (head.sort !== '') {
      return (
        <Table.HeaderCell
          key={index}
          width={head.width}
          sorted={props.column === head.sort ? props.direction : null}
          onClick={() => props.handleSort(head.sort)}
        >
          {head.title}
        </Table.HeaderCell>
      );
    } else {
      return (
        <Table.HeaderCell key={index} width={head.width}>
          {head.title}
        </Table.HeaderCell>
      );
    }
  });

  return (
    <Table.Header>
      <Table.Row>{tableHeader}</Table.Row>
    </Table.Header>
  );
}

VerifiedCallerIdTableHeader.propTypes = {
  header: PropTypes.array.isRequired,
  column: PropTypes.string,
  direction: PropTypes.string,
  handleSort: PropTypes.func.isRequired,
};
